import React from "react"
import { Button, Grid, Typography } from "@material-ui/core"
import Bar from "./bar"
import CardSlideshow from "./card-slideshow"
import { trendArticles } from "../data/trend-articles"

const topics = [
  {
    slug: "childrens-books",
    title: "Books to discover",
    description:
      "Explore reading picks for children and teens, and find something to make time for.",
  },
  {
    slug: "online-courses",
    title: "Something new to learn",
    description:
      "Discover online courses and learning resources to give a new interest a place in your week.",
  },
  {
    slug: "study-apps",
    title: "Tools for your study time",
    description:
      "Explore study apps and learning tools in the weekly selections.",
  },
  {
    slug: "language-learning",
    title: "A world of languages",
    description:
      "Find language-learning resources to inspire your next practice session.",
  },
  {
    slug: "coding-ai-learning",
    title: "Explore coding and AI",
    description:
      "Browse coding and AI learning ideas, from first steps to new skills.",
  },
  {
    slug: "learning-games",
    title: "Make learning playful",
    description:
      "Discover learning games and ideas to bring some play into your routine.",
  },
  {
    slug: "music-learning",
    title: "Make time for music",
    description:
      "Explore music-learning resources and inspiration for your practice time.",
  },
  {
    slug: "childrens-activities",
    title: "After-school inspiration",
    description:
      "Find activities to try at home and ideas for a more varied school week.",
  },
  {
    slug: "study-methods",
    title: "Fresh study ideas",
    description:
      "Explore study approaches and research leads, with context to help you decide what to try.",
  },
  {
    slug: "school-holiday-activities",
    title: "Holiday ideas to explore",
    description:
      "Browse activities and learning ideas to help plan your next school break.",
  },
]

const TrendsPreview = () => (
  <Grid
    component="section"
    container
    spacing={3}
    style={{ textAlign: "center", padding: "32px 10px 48px" }}
  >
    <Grid item xs={12}>
      <Typography variant="h5" component="h2">
        Fresh ideas for your week.
      </Typography>
      <Bar />
      <Typography
        variant="subtitle1"
        color="textSecondary"
        style={{ margin: "24px auto", maxWidth: 680 }}
      >
        Explore our weekly picks for books, courses, apps and activities. Find
        something that sparks your interest and make time for it.
      </Typography>
    </Grid>
    <CardSlideshow
      label="Weekly learning trends"
      items={topics.map((topic) => ({
        ...topic,
        image: trendArticles.find(article => article.slug === topic.slug)!.image,
        url: `/trends/${topic.slug}/`,
      }))}
    />
    <Grid item xs={12}>
      <Button variant="outlined" color="primary" size="large" href="/trends/">
        Explore all weekly trends
      </Button>
    </Grid>
  </Grid>
)

export default TrendsPreview
